import { Container, Row, Col } from 'react-bootstrap';
import Reminders from './reminder/reminder';
import WelcomeCard from './welcomeCard/welcomeCard'
import NotificationPage from '../notifications/notificationsPage';

function HomeWeb() {

  return (
    <Container fluid className="p-4">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={12}>
          <div className="mb-4">
            <WelcomeCard />
          </div>
          <div>
            <Reminders />
          </div>
        </Col>
      </Row>
      <NotificationPage />
    </Container>
  );
}

export default HomeWeb;

